import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function IncomeStatementReport() {
  return <ReportForm reportAPI={ ReportAPI.INCOME_STATEMENT } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/IncomeStatementReport.js